import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { code: "", percent: 10, active: true, starts_at: "", ends_at: "" };

function statusOf(p) {
  const today = new Date().toISOString().slice(0, 10);
  if (!p.active) return { label: "Inactif", color: "var(--lo-muted)" };
  if (p.starts_at && today < p.starts_at) return { label: "À venir", color: "#d0a24a" };
  if (p.ends_at && today > p.ends_at) return { label: "Expiré", color: "#e06666" };
  return { label: "Actif", color: "var(--lo-rose-hi)" };
}

export function AdminPromos() {
  const [promos, setPromos] = useState([]);
  const [adding, setAdding] = useState(false);
  const [np, setNp] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/promos").then((r) => setPromos(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!np.code || !np.percent) { toast.error("Code et pourcentage requis"); return; }
    setBusy(true);
    try {
      const payload = { ...np, percent: Number(np.percent), starts_at: np.starts_at || null, ends_at: np.ends_at || null };
      await api.post("/admin/promos", payload);
      setAdding(false); setNp(EMPTY); load();
      toast.success("Code promo créé");
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur de création"); }
    finally { setBusy(false); }
  };

  const toggle = async (p) => { await api.put(`/admin/promos/${p.id}`, { active: !p.active }); load(); };
  const del = async (p) => { if (!window.confirm(`Supprimer le code ${p.code} ?`)) return; await api.delete(`/admin/promos/${p.id}`); load(); toast.success("Code supprimé"); };

  return (
    <div className="space-y-4" data-testid="admin-promos">
      <div className="flex justify-end">
        <button onClick={() => setAdding((v) => !v)} className="btn-ghost inline-flex items-center gap-2 h-10 px-5" data-testid="promo-add-toggle"><Plus size={15} /> Nouveau code</button>
      </div>
      {adding && (
        <div className="card-lux p-5" data-testid="promo-new-form">
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 items-end">
            <label className="block"><span className="overline block mb-1" style={{ fontSize: "0.55rem" }}>Code</span>
              <input value={np.code} onChange={(e) => setNp({ ...np, code: e.target.value.toUpperCase() })} placeholder="ETE20" className="w-full bg-transparent border-b py-2 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="promo-new-code" /></label>
            <label className="block"><span className="overline block mb-1" style={{ fontSize: "0.55rem" }}>Réduction %</span>
              <input type="number" value={np.percent} onChange={(e) => setNp({ ...np, percent: e.target.value })} className="w-full bg-transparent border-b py-2 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="promo-new-percent" /></label>
            <label className="block"><span className="overline block mb-1" style={{ fontSize: "0.55rem" }}>Début</span>
              <input type="date" value={np.starts_at} onChange={(e) => setNp({ ...np, starts_at: e.target.value })} className="w-full bg-transparent border-b py-2 text-sm outline-none" style={{ borderColor: "var(--lo-border)", colorScheme: "dark" }} data-testid="promo-new-start" /></label>
            <label className="block"><span className="overline block mb-1" style={{ fontSize: "0.55rem" }}>Fin</span>
              <input type="date" value={np.ends_at} onChange={(e) => setNp({ ...np, ends_at: e.target.value })} className="w-full bg-transparent border-b py-2 text-sm outline-none" style={{ borderColor: "var(--lo-border)", colorScheme: "dark" }} data-testid="promo-new-end" /></label>
            <button onClick={create} disabled={busy} className="btn-primary h-10 px-6 disabled:opacity-50" data-testid="promo-new-create">{busy ? "…" : "Créer"}</button>
          </div>
        </div>
      )}
      {promos.length === 0 ? <p className="text-sm" style={{ color: "var(--lo-muted)" }}>Aucun code promo.</p> : promos.map((p) => {
        const st = statusOf(p);
        return (
          <div key={p.id} className="card-lux p-5 flex justify-between items-center gap-4" data-testid={`promo-${p.code}`}>
            <div>
              <p className="font-display text-xl">{p.code} <span className="rose-gold-text">−{p.percent}%</span></p>
              <p className="text-xs mt-1" style={{ color: "var(--lo-muted)" }}>
                {p.starts_at || "toujours"} → {p.ends_at || "sans limite"}
              </p>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <span className="overline" style={{ fontSize: "0.55rem", color: st.color }}>{st.label}</span>
              <button onClick={() => toggle(p)} className="btn-ghost h-9 px-4 text-xs" data-testid="promo-toggle">{p.active ? "Désactiver" : "Activer"}</button>
              <button onClick={() => del(p)} className="w-9 h-9 flex items-center justify-center border" style={{ borderColor: "var(--lo-border)" }} data-testid="promo-delete"><Trash2 size={15} /></button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
